export default __webpack_public_path__ + "static/competitive-analysis-fcae8cd54fd35f1dde9736758304e651.png";